var $searchIcon = $('.header__search__icon');
var $searchInput = $('.header__right .header__search');
var $mobileSearchContainer = $('.search__mobile');
var $mobileUserPopover = $('.user .popover');
var $mobileSearchInput = $('.mobile-search.header__search');
var $mobileHeaderBanner = $('.header-banner');
var $menuList = $('.menu__list');
var $menuLink = $('.menu__link');
var $dropdownLink = $('.dropdown-link');
var $dropdownItem = $('.dropdown-item');
const postalCodeTooltip = $('[js-postal-code-tooltip]');
var $lgbreakpoint = 1357;
var $mdBreakPoint = 760;

function toggleSearch() {
    if ($(window).width() > $lgbreakpoint) {
        if ($searchInput.hasClass('d-none')) {
            $searchInput.removeClass('d-none');
        } else if ($searchInput.val() === '') {
            $searchInput.addClass('d-none');
            $searchIcon.removeClass('d-none');
        }
    } else if ($(window).width() < $lgbreakpoint) {
        if ($mobileSearchInput.hasClass('d-none')) {
            $mobileSearchInput.removeClass('d-none');

            if ($mobileHeaderBanner !== undefined && $mobileHeaderBanner !== null) {
                var height = `${$mobileHeaderBanner.height() + 68}px`;
                $mobileSearchContainer.css('top', height);
            }
        } else {
            $mobileSearchInput.addClass('d-none');
        }
    }
}

$('.close-menu .close-button').on('click', function (event) {
    event.preventDefault();

    $menuList.removeAttr('style');
    $menuLink.removeAttr('style');
    $dropdownItem.removeAttr('style');
    $dropdownLink.removeAttr('style');
});

$(document).on('click', function (event) {
    if ($(event.target).closest($searchIcon).length) {
        toggleSearch();
    } else if (!$(event.target).closest('.header__right .header__search').length) {
        if (!$searchInput.hasClass('d-none') && $searchInput.val() === '') {
            $searchInput.addClass('d-none');
            $searchIcon.removeClass('d-none');
        }
    }
});

// fix header on top on scrolldown
$(document).ready(function () {
    $(window).scroll(function () {
        const $header = $('header');
        const $filterHeader = $('.filter-header-fixed');
        const scrollPos = $(this).scrollTop();
        const isMobile = window.matchMedia("(max-width: 767px)").matches;

        if (scrollPos > 0) {
            $header.addClass('fixed');
            $filterHeader.css('top', $header.height() - 3); 
            postalCodeTooltip.addClass('d-none');
        } else {
            if (!isMobile) {
                $header.removeClass('fixed');
                $filterHeader.css('top', 0);
            }
        }
    });
});

// hide/show user profile panel
$(document).ready(function () {
    var $user = $('.navbar-header .user');

    function openPopover($el) {
        var $popover = $el.find('.popover');

        $mobileUserPopover.removeClass('show').removeAttr('style');
        $user.attr('aria-expanded', 'false');

        if ($(window).width() < $mdBreakPoint) {
            var height = ($mobileHeaderBanner && $mobileHeaderBanner.length > 0) ?
                ($mobileHeaderBanner.height() + 63) + 'px' : '113px';
            $popover.css('top', height);
            $popover.siblings('.popover-overlay').css('top', height);
        } else {
            $popover.removeAttr('style');
            $popover.siblings('.popover-overlay').removeAttr('style');
        }

        $popover.addClass('show');
        $el.attr('aria-expanded', 'true');
    }

    function closePopover($el) {
        var $popover = $el.find('.popover');
        $popover.removeClass('show').removeAttr('style');
        $el.attr('aria-expanded', 'false');
    }

    // Abrir popover
    $user.on('mouseenter focusin click', function (e) {
        // Prevenir default solo si el click es sobre el .user, no sobre sus hijos
        if (e.type === 'click' && $(e.target).is('.user')) {
            e.preventDefault();
        }
        openPopover($(this));
    });

    // Cerrar popover al hacer click en el botón de cerrar
    $(document).on('click', '.closeProfileMenu', function (e) {
        e.preventDefault();
        var $userEl = $(this).closest('.user');
        closePopover($userEl);
    });

    // Cerrar popover al salir con el mouse (solo en desktop)
    $user.on('mouseleave', function () {
        if ($(window).width() >= $mdBreakPoint) {
            closePopover($(this));
        }
    });

    // Cerrar popover al hacer click fuera
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.user').length) {
            $user.each(function () {
                closePopover($(this));
            });
        }
    });
});
// show/hide search icon inside the search input if its not empty
$(document).ready(function () {
    if ($(window).width() > $lgbreakpoint) {
        var searchIcon = $('.search-icon-input');
        $('.header__search .form-control.search-field').on('keyup', function () {
            if ($(this).val().length > 3) {
                $(searchIcon).addClass('d-none');
                $('.fa-times.reset-button').addClass('d-sm-block');
            } else if ($(this).val().length < 3) {
                $(searchIcon).removeClass('d-none');
                $('.fa-times.reset-button').removeClass('d-sm-block');
            }
        });
        $('.fa-times.reset-button').on('click', function () {
            searchIcon.removeClass('d-none');
        });
    }
});

function handleClosePostalCodeModal(hasSessionPostalCode, modal, openTooltipValidation) {
    modal.addClass('d-none');
    $('body').removeAttr('style');

    if (!hasSessionPostalCode && openTooltipValidation) postalCodeTooltip.removeClass('d-none');
}

$(document).ready(function () {
    const enableStoreSelector = $('[name="enableStoreSelector"]').val() === 'true';

    // If the Store Selector is enabled, do not initialize the postal code modal
    if (enableStoreSelector) {
        return;
    }

    const modal = $('.js-modal-postal');
    const hasSessionPostalCode = modal.find('[js-session-postal-code]').val() == 'true';
    const firstVisitKey = 'firstVisit';
    const openTabsKey = 'openTabs';
    const sessionActiveKey = 'sessionActive';

    function isFirstTime() {
        return !localStorage.getItem(firstVisitKey);
    }

    function getOpenTabs() {
        return parseInt(localStorage.getItem(openTabsKey) || '0', 10);
    }

    function incrementOpenTabs() {
        localStorage.setItem(openTabsKey, Math.max(getOpenTabs() + 1));
    }

    function decrementOpenTabs() {
        localStorage.setItem(openTabsKey, Math.max(getOpenTabs() - 1, 0));
    }

    function isReturningAfterClose() {
        return !sessionStorage.getItem(sessionActiveKey) && getOpenTabs() === 0;
    }

    function markSessionActive() {
        sessionStorage.setItem(sessionActiveKey, 'true');
    }

    function onFirstVisitOrReturn() {
        if (!hasSessionPostalCode) {
            $('body').css('overflow-y', 'hidden');
            modal.removeClass('d-none');
        }
    }

    let openTooltipValidation = isFirstTime() || isReturningAfterClose();

    if (isFirstTime() || isReturningAfterClose()) {
        onFirstVisitOrReturn();
        localStorage.setItem(firstVisitKey, true);
    }

    $('.postal-code-text , .show-postal-code-popUp').on('click', function () {
        $('body').css('overflow-y', 'hidden');
        modal.removeClass('d-none');
    });

    $('.close-img').on('click', function () {
        handleClosePostalCodeModal(hasSessionPostalCode, modal, openTooltipValidation);
    });

    window.onclick = function (event) {
        if ($(event.target).attr('class') === 'simple-modal') {
            handleClosePostalCodeModal(hasSessionPostalCode, modal, openTooltipValidation);
        }
    };

    $('.js-postal-code').on('submit', function (e) {
        e.preventDefault();
        const url = $('.js-postal-code').attr('action');
        const input = $('.js-postal-code').find('input');

        let formData = {};
        let inputId = input.attr('id');
        formData[inputId] = input.val();

        $.ajax({
            url: url,
            type: 'POST',
            dataType: 'json',
            data: formData,
            success: function (response) {
                if (response.success) {
                    window.location.reload();
                }
            }
        });
    });

    $('[data-reset-postal-code]').on('click', function () {
        const url = $(this).data('url');
        let formData = {};
        $.ajax({
            url: url,
            type: 'POST',
            dataType: 'json',
            data: formData,
            success: function (response) {
                if (response.success) {
                    window.location.reload();
                }
            }
        });
    });

    markSessionActive();
    incrementOpenTabs();

    window.addEventListener('beforeunload', function () {
        decrementOpenTabs();
    });
});
